import moment from 'moment';

export function isDateValid() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return !value || typeof value !== 'string' ? false : moment(value, [moment.ISO_8601, 'L'], 'pt-br', true).isValid();
}

export function toDateString() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return moment(value).format('L');
}

export function formatDateStringToISO() {
    var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    // Para manter compatibilidade com registros antigos. Tem vezes que o formato é dd/MM/yyyy e tem vezes que o formato é ISO-8601.
    return moment(value, [moment.ISO_8601, 'L'], 'pt-br').toISOString();
}